export default __webpack_public_path__ + "static/media/robo-form.54e7983f.svg";